export const MEDSTRAT_HOLDING = 'MedStrat Patient Holding Tank';